module.exports = __webpack_public_path__ + "static/media/brendon.919e6846.jpg";